import React from 'react';
import { Menu as AntMenu } from 'antd';
import PropTypes from 'prop-types';
import routesToMenuItems from './routesToMenuItems';

const Menu = ({
  items,
  routes,
  defaultSelectedKeys,
  collapsedSidebar,
  onSelect,
  forPermission,
  selectedKeys,
}) => (
  <AntMenu
    className="side-menu"
    theme="light"
    mode="inline"
    defaultSelectedKeys={defaultSelectedKeys}
    items={items || routesToMenuItems({ routes, collapsedSidebar, forPermission })}
    onSelect={onSelect}
    selectedKeys={selectedKeys}
  />
);

Menu.propTypes = {
  routes: PropTypes.arrayOf(PropTypes.shape()),
  items: PropTypes.arrayOf(PropTypes.shape()),
  defaultSelectedKeys: PropTypes.arrayOf(PropTypes.string),
  selectedKeys: PropTypes.arrayOf(PropTypes.string),
  collapsedSidebar: PropTypes.bool,
  onSelect: PropTypes.func,
  forPermission: PropTypes.bool,
};

Menu.defaultProps = {
  routes: [],
  items: null,
  defaultSelectedKeys: [],
  selectedKeys: undefined,
  collapsedSidebar: false,
  forPermission: false,
  onSelect: null,
};

export default Menu;
